export const BIG_ORBIT_COEFF = 0.9
export const MEDIUM_ORBIT_COEFF = 0.65
export const SMALL_ORBIT_COEFF = 0.4

export const ICON_SIZE = 64
